(function () {
  function isStore99Item(item) {
    return item && item.properties && item.properties[STORE_99_KEY] === STORE_99_VALUE;
  }

  function showBlockMessage(triggerEl, message, onConfirm) {
    const popup = document.createElement('div');
    popup.style.cssText = `position: fixed;top: 0; left: 0;width: 100%; height: 100%;background: rgba(0,0,0,0.45);z-index: 999999;display: flex;align-items: center;justify-content: center;`;

    const box = document.createElement('div');
    box.style.cssText = `background: #fff;padding: 20px;border-radius: 10px;width: 320px;font-size: 14px;text-align: center;`;

    box.innerHTML = `<p style="margin-bottom:16px;">${message}</p>
      <button id="popup-ok" style="padding:8px 16px;margin-right:10px;background:#ddd;color:#222;border-radius:6px;cursor:pointer;">Remove Item</button>
      <button id="popup-cancel" style="padding:8px 16px;background:#222;color:#fff;border-radius:6px;cursor:pointer;">I Want the Deal!</button>`;

    popup.appendChild(box);
    document.body.appendChild(popup);

    popup.querySelector('#popup-ok').addEventListener('click', () => {
      popup.remove(); 
      if (typeof onConfirm === 'function') onConfirm();
    });

    popup.querySelector('#popup-cancel').addEventListener('click', () => { 
      popup.remove();
      hideCartDrawerLoading();
    });
  }
  
  async function fetchCartJson() {
    try {
      const url = window.FoxTheme?.routes?.cart_url || '/cart.js';

      let config = window.FoxTheme?.utils?.fetchConfig
        ? { ...FoxTheme.utils.fetchConfig() }
        : { method: 'GET', headers: { 'Content-Type': 'application/json' } };

      config.method = 'GET';
      delete config.body;
      config.headers = config.headers || {};
      config.headers['Accept'] = 'application/json';

      const res = await fetch(url, config);
      return await res.json();
    } catch (e) {
      console.error('[store99-cart-rules] Error fetching cart:', e);
      return null;
    }
  }

  async function handleRemoveClick(event) {
    const btn = event.target.closest('.quantity__button[name="minus"]');

    if (btn) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showCartDrawerLoading();

      const wrapper = btn.closest('quantity-input') || btn.closest('.cart-quantity') || btn.closest('.quantity');
      if (!wrapper) return;

      const input = wrapper.querySelector('.quantity__input') || wrapper.querySelector('input[type="number"]');
      if (!input) return;

      handleMinusClick(btn, input);
      return;
    }

    const link = event.target.closest('a[is="cart-remove-item"]');
    if (!link) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showCartDrawerLoading();

    const cartItemsEl = link.closest('cart-items');
    const lineStr = link.dataset.index;
    const line = parseInt(lineStr, 10);

    const cartJson = await fetchCartJson();
    if (!cartJson?.items) {
      if (cartItemsEl?.updateQuantity) cartItemsEl.updateQuantity(lineStr, 0);
      return;
    }

    const items = cartJson.items;
    const hasStore99 = items.some(isStore99Item);
    const lineItem = items[line - 1];

    if (!hasStore99) {
      if (cartItemsEl?.updateQuantity) cartItemsEl.updateQuantity(lineStr, 0);
      return;
    }

    if (isStore99Item(lineItem)) {
      cartItemsEl.updateQuantity(lineStr, 0);
      return;
    }

    const nonStore99Items = items.filter(i => !isStore99Item(i));
    const nonStore99Count = nonStore99Items.length;

    const nonStore99TotalNow = nonStore99Items.reduce(
      (sum, i) => sum + (i.price || 0) * (i.quantity || 0), 0
    );

    const thisLineValue = (lineItem.price || 0) * (lineItem.quantity || 0);
    const nonStore99TotalAfter = nonStore99TotalNow - thisLineValue;

    if (nonStore99Count <= 1 || nonStore99TotalAfter < MIN_CART_TOTAL_PAISA) {
      const msg =
        nonStore99TotalAfter < MIN_CART_TOTAL_PAISA
          ? `Are you sure? Removing this item will also remove your ₹99 Store Deal.`
          : 'This Store 99 product can only be purchased with other items.';
      showBlockMessage(link, msg, async () => {
        const store99Lines = items.map((item, idx) => ({ item, line: idx + 1 })).filter(obj => isStore99Item(obj.item));
        const updates = {};
        store99Lines.forEach(obj => { updates[obj.item.variant_id] = 0; });
        updates[lineItem.variant_id] = 0;
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        if (milestoneflag) refreshPerksAndGifts();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
      return; 
    } else {
      cartItemsEl.updateQuantity(lineStr, 0);
      return;
    }
  }

  async function handleMinusClick(btn, input) {
    const indexAttr = input.getAttribute('data-index');
    const curentVId = input.getAttribute('data-quantity-variant-id');
    const indexItemPrice = Number(input.getAttribute('data-item-price') || 0);
    const line = parseInt(indexAttr, 10);

    const cartJson = await fetchCartJson();
    const items = cartJson?.items || [];

    const hasStore99 = items.some(isStore99Item);

    let min = 1;
    let current = parseInt(input.value || String(min), 10);
    const next = current - 1;

    if (!hasStore99) {
      input.value = Math.max(next, min);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const nonStore99Items = items.filter(i => !isStore99Item(i));

    const nonStore99TotalNow = nonStore99Items.reduce(
      (sum, i) => sum + (i.price || 0) * (i.quantity || 0), 0
    );

    const nonStore99TotalAfter = nonStore99TotalNow - indexItemPrice;
    console.log(nonStore99TotalAfter);
    console.log(MIN_CART_TOTAL_PAISA);

    if (nonStore99TotalAfter < MIN_CART_TOTAL_PAISA) {
      const msg = `Are you sure? Removing this item will also remove your ₹99 Store Deal.`;

      showBlockMessage(input, msg, async () => {
        const store99Lines = items.map((item, idx) => ({ item, line: idx + 1 })).filter(obj => isStore99Item(obj.item));
        const updates = {};
        store99Lines.forEach(obj => { updates[obj.item.variant_id] = 0; });
        updates[curentVId] = next;
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        if (milestoneflag) refreshPerksAndGifts();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
      return;
    } else {
      input.value = Math.max(next, min);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }

  /*   Gift Tire */
  const INCLUDE_GIFTS_IN_SUBTOTAL = false;

  const GIFT_VARIANT_IDS = new Set(
    PERK_TIERS
      .filter(function (t) { return t.type === 'gift'; })
      .map(function (t) { return String(t.variantId); })
  );

  function formatMoney(paise) { return '₹' + (paise / 100).toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1'); }

  function getQualifyingSubtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      var isGiftVariant = GIFT_VARIANT_IDS.has(String(item.variant_id));
      if (!INCLUDE_GIFTS_IN_SUBTOTAL && isGiftVariant) return sum;
      return sum + (item.price || 0) * (item.quantity || 0);
    }, 0);
  }

  function getNextTier(subtotal) {
    for (var i = 0; i < PERK_TIERS.length; i++) {
      if (subtotal < PERK_TIERS[i].threshold) { return PERK_TIERS[i]; }
    } return null;
  }

  function calculateTierProgress(subtotal) {
    var totalTiers = PERK_TIERS.length;
    if (totalTiers === 0) return 0;
    var perTier = 100 / totalTiers;
    for (var i = 0; i < totalTiers; i++) {
      var tier = PERK_TIERS[i];
      if (subtotal < tier.threshold) {
        var prevThreshold = i === 0 ? 0 : PERK_TIERS[i - 1].threshold;
        var tierRange = tier.threshold - prevThreshold;
        var progressInTier = subtotal - prevThreshold;
        if (tierRange <= 0) return i * perTier;
        var baseFromPrevTiers = i * perTier;
        var withinCurrent = (progressInTier / tierRange) * perTier;
        var result = baseFromPrevTiers + withinCurrent;
        if (result < 0) result = 0;
        if (result > 100) result = 100;
        return result;
      }
    }
    return 100;
  }

  function updatePerksUI(subtotal) {
    var perksEl = document.querySelector('[data-cart-perks]');
    if (!perksEl) return;
    var progressFill = perksEl.querySelector('[data-cart-perks-progress]');
    var progressTextEl = perksEl.querySelector('[data-cart-perks-progress-text]');
    var percent = calculateTierProgress(subtotal);
    if (progressFill) { progressFill.style.width = percent + '%'; }
    var nextTier = getNextTier(subtotal);
    if (progressTextEl) {
      if (!nextTier) {
        progressTextEl.textContent = 'You unlocked all rewards!';
      } else {
        var remaining = nextTier.threshold - subtotal;
        var rewardName = nextTier.headlineLabel || nextTier.label;
        progressTextEl.textContent = 'You are ' + formatMoney(remaining) + ' away from ' + rewardName;
      }
    }

    PERK_TIERS.forEach(function (tier) {
      var li = perksEl.querySelector('[data-perk="' + tier.id + '"]');
      if (!li) return;
      var remainingTier = tier.threshold - subtotal;
      if (subtotal >= tier.threshold) {
        li.classList.add('is-achieved');
        li.classList.remove('is-current');
      } else {
        li.classList.remove('is-achieved');
      }
      if (nextTier && nextTier.id === tier.id) {
        li.classList.add('is-current');
      } else {
        li.classList.remove('is-current');
      }
    });
  }

  async function syncGiftsFromCart(cart, subtotal) {
    console.log('syncGiftsFromCart');
    var desiredGiftVariantIds = new Set(
      PERK_TIERS
        .filter(function (tier) { return tier.type === 'gift' && subtotal >= tier.threshold; })
        .map(function (tier) { return String(tier.variantId); })
    );

    var allGiftVariantIds = GIFT_VARIANT_IDS;
    var toRemoveLines = [];
    var presentGiftVariantIds = new Set();

    cart.items.forEach(function (item, index) {
      var variantIdStr = String(item.variant_id);
      if (!allGiftVariantIds.has(variantIdStr)) return;

      if (!desiredGiftVariantIds.has(variantIdStr)) {
        toRemoveLines.push(variantIdStr);
      } else {
        presentGiftVariantIds.add(variantIdStr);
      }
    });

    var toAddVariantIds = Array.from(desiredGiftVariantIds).filter(function (id) {
      return !presentGiftVariantIds.has(id);
    });
    var changed = false;

    if (toRemoveLines.length > 0) {
      const updates = {};
      toRemoveLines.forEach(line => { updates[line] = 0; });
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        changed = true;
      } catch (e) {
        console.error('[perks-gifts] Error multi-removing gift lines', e);
      }
    }
    
    if (toAddVariantIds.length > 0) {
      const items = [];
      for (var j = 0; j < toAddVariantIds.length; j++) {
        var variantIdStr = toAddVariantIds[j];
        var tierCfg = PERK_TIERS.find(function (t) {
          return t.type === 'gift' && String(t.variantId) === variantIdStr;
        });
        if (!tierCfg) continue;
        items.push({
          id: Number(variantIdStr),
          quantity: 1,
          properties: { _free_gift: tierCfg.id }
        });
      }
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });
        changed = true;
      } catch (e) {
        console.error('[perks-gifts] Error adding gift items', e);
      }
    }
    
    if (changed) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }}));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => {
        updatePerksUI(subtotal);
      }, 1500);
    } else {
      hideCartDrawerLoading()
    }
  }

  async function refreshPerksAndGifts() {
    showCartDrawerLoading();
    var cart = await fetchCartJson();
    if (!cart || !Array.isArray(cart.items)) return;
    var subtotal = getQualifyingSubtotal(cart);
    updatePerksUI(subtotal);
    enforceFreeGiftQtyOne();
    await syncGiftsFromCart(cart, subtotal);
  }

  function showCartDrawerLoading() {
    const drawer = document.querySelector('.cart-drawer .drawer__inner');
    if (!drawer) return;
    drawer.classList.add('is-loading');
  }

  function hideCartDrawerLoading() {
    enforceFreeGiftQtyOne();
    const drawer = document.querySelector('.cart-drawer .drawer__inner');
    if (!drawer) return;
    drawer.classList.remove('is-loading');
  }

  function initPerksAndGifts() {
    refreshPerksAndGifts();
    document.addEventListener('cart:updated', function () { refreshPerksAndGifts(); });
    document.addEventListener('cart-drawer:opened', function () { refreshPerksAndGifts(); });
  }

  function enforceFreeGiftQtyOne() { 
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => { console.log('check');
        // Check line-item property
        if (
          item.properties &&
          item.properties._free_gift &&
          item.quantity > 1
        ) {
          updates[item.key] = (item.id == 52809625010451)?0:1;
        }
      });

      if (Object.keys(updates).length === 0) return;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    });
  }

  function init() {
    if (storeflag) document.addEventListener('click', handleRemoveClick, true);
    if (milestoneflag) document.addEventListener('DOMContentLoaded', initPerksAndGifts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();